import { useCallback } from 'react'
import { DocumentPaymentDetailInput, FiscalType, ReservationDetailDocument, useCreateDepositMutation } from 'src/api/api.generated'
import { Currency } from 'src/api/currency'
import { useTenant } from 'src/app/hooks/context/context.hook'
import syncMutation from 'src/utils/sync-mutation'

export type CreateReservationDepositInput = {
  reservationId: string
  amount: number
  cashDeskId: string
  customerId: string
  currency: Currency
  fiscalType: FiscalType
  payments: DocumentPaymentDetailInput[]
  scelNote?: string
  vatId?: string
}

export default function useCreateReservationDeposit(propertyId: string) {
  const [createDepositMutation] = useCreateDepositMutation()
  const tenantId = useTenant().id
  const createDeposit = useCallback(
    async (input: CreateReservationDepositInput) => {
      const result = syncMutation(createDepositMutation, {
        variables: {
          input: {
            tenantId: tenantId,
            amount: input.amount,
            cashDeskId: input.cashDeskId,
            currency: input.currency,
            fiscalType: input.fiscalType,
            vatId: input.vatId,
            payments: input.payments,
            customerId: input.customerId,
            depositAssignments: [{ amount: input.amount, reservationId: input.reservationId }],
            draft: false,
            scelNote: input.scelNote,
          },
        },
        refetchQueries: [{ query: ReservationDetailDocument, variables: { propertyId, tenantId, reservationId: input.reservationId } }],
      })
      return result
    },
    [tenantId],
  )
  return createDeposit
}
